import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=ae4a10a8&scoped=true&"
import script from "./FolderItem.vue?vue&type=script&lang=js&"
export * from "./FolderItem.vue?vue&type=script&lang=js&"
import style0 from "./FolderItem.vue?vue&type=style&index=0&id=ae4a10a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4a10a8",
  null
  
)

export default component.exports